function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "2gne8n5d0a",
  d: "M9 11.498c-.66 0-1.288-.28-1.73-.767-.004.048-.004.096 0 .144.11.863.86 1.5 1.73 1.465.87.034 1.62-.602 1.73-1.465.004-.048.004-.096 0-.144-.442.488-1.07.766-1.73.767m2.885-6.386c-.03-.717-.61-1.287-1.327-1.304-.71.026-1.277.595-1.304 1.304.026.71.594 1.28 1.304 1.31.718-.019 1.3-.592 1.327-1.31zm-3.202 0c-.027-.716-.606-1.287-1.321-1.304-.71.026-1.28.594-1.31 1.304.027.711.598 1.282 1.31 1.31.71-.03 1.277-.6 1.303-1.31h.018zM9 13.615c1.912 0 3.462-1.55 3.462-3.461 0-1.912-1.55-3.462-3.462-3.462-1.912 0-3.462 1.55-3.462 3.462 0 1.912 1.55 3.461 3.462 3.461zm0 2.308c-3.824 0-6.923-3.1-6.923-6.923 0-3.824 3.1-6.923 6.923-6.923 3.824 0 6.923 3.1 6.923 6.923 0 1.836-.73 3.597-2.028 4.895-1.298 1.299-3.059 2.028-4.895 2.028z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1496 -1049) translate(1174 288) translate(0 64) translate(16 630) translate(238 64) translate(68 3)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "peagzyfc3b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#2gne8n5d0a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#454555",
  xlinkHref: "#2gne8n5d0a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#8CB42C",
  mask: "url(#peagzyfc3b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H18V18H0z"
})))))))));

var SvgIcnFilledOSCoinsGreen = function SvgIcnFilledOSCoinsGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnFilledOSCoinsGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-filled-o-s-coins-green.6b2aed15.svg";
export { ForwardRef as ReactComponent };